import { FC } from 'react';
import clsx from 'clsx';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { InlineMessages, InlineMessagesType } from '@marriott/mi-ui-library';
import { AlertBannerProps } from './AlertBanner.types';
import { StyledAlertBanner } from './AlertBanner.styles';

export const alertBannerConfig = {
  emptyLabel: 'AlertBanner',
  isEmpty: () => true,
  resourceType: `/components/content/alertbanner`,
};

export const AlertBannerComp: FC<AlertBannerProps> = (props: AlertBannerProps) => {
  const { title, message, styleclass, showError, isAuthorMode } = props;

  return (
    <StyledAlertBanner
      data-component-name="o-cobrand-AlertBanner"
      data-testid="cobrand-AlertBanner"
      className={clsx(styleclass, 'py-3', showError || isAuthorMode ? '' : 'd-none')}
    >
      <InlineMessages title={title} messageList={[message]} type={InlineMessagesType.Warning} />
    </StyledAlertBanner>
  );
};

AlertBannerComp.displayName = 'AlertBannerComp';

export const AlertBanner: FC<AlertBannerProps> = (props: AlertBannerProps) => {
  return (
    <EditableComponent config={alertBannerConfig} {...props}>
      <AlertBannerComp {...props} />
    </EditableComponent>
  );
};
